import React from 'react';
import ReactDOM from 'react-dom'; // React 17 API
import { ChakraProvider } from '@chakra-ui/react';
import { app } from '@/App';
import { errorBoundary } from '@/components/error-boundary';
import { storeProvider } from '@/stores/store-provider';
import { AuthProvider } from '@/providers/auth-provider';
import { ContinuumProvider } from '@/lib/continuum';
import { chakraTheme } from '@/lib/chakra-theme';
import { ToasterConfig } from '@/components/toaster-config';
import { AnalyticsProvider, AnalyticsEnricher } from '@/analytics';

const element = document.querySelector('#root');

// React 17 pattern - Uses ReactDOM.render()
if (element) {
  const AppComponent = app;
  const ErrorBoundaryComponent = errorBoundary;
  const StoreProviderComponent = storeProvider;
  const AuthProviderComponent = AuthProvider;
  const ContinuumProviderComponent = ContinuumProvider;

  ReactDOM.render(
    <React.StrictMode>
      <ErrorBoundaryComponent>
        <AnalyticsProvider>
          <StoreProviderComponent>
            <AuthProviderComponent>
              <AnalyticsEnricher>
                <ChakraProvider theme={chakraTheme}>
                  <ContinuumProviderComponent>
                    <AppComponent />
                    <ToasterConfig />
                  </ContinuumProviderComponent>
                </ChakraProvider>
              </AnalyticsEnricher>
            </AuthProviderComponent>
          </StoreProviderComponent>
        </AnalyticsProvider>
      </ErrorBoundaryComponent>
    </React.StrictMode>,
    element
  );
}
